<template>
  <div class="container resultsViewContainer my-4">
    <div class="row">
      <c-filter v-if="!mobileFilterShow" :location="location" @filter-selected="onFilterSelected"></c-filter>
      <c-search-results @sort="onSort"></c-search-results>
    </div>
  </div>
</template>

<script>
import { handleFilterSelected, fetch } from '@/views/results/resultsHelpers'
import {
  alterHeaderSearchValue,
  alterMobileHeaderSearchValue,
  emptyFetch,
} from '@/utilities/bruteForce'
import { MOBILE_WIDTH } from '@/utilities/constants'
import { addId } from '@/utilities/functions'

export default {
  computed: {
    mobileFilterShow(){
      return this.$store.getters['search/showFilterOnMobile'];
    },
    allCategoriesAndTags() {
      return this.$store.getters['search/allCategoriesAndTags']
    },
    location() {
      return this.$route.query.location || ''
    },
    queryParams() {
      return this.$store.getters['search/params']
    },
    results() {
      return this.$store.getters['search/results']
    },
  },
  created() {
    this.onCreated()
  },
  methods: {
    addIds(hcat) {
      if (hcat == null){
        return null
      }
      return addId(
        hcat.map(c => ({
          ...c,
          tags: addId(
            c.tags.map(t => ({ ...t, tag: t.name, text: t.name, name: t.name, value: t.name }))
          ),
        }))
      )
    },

    async emptyFetch() {
      const res = await emptyFetch(this)
      const { healthCategoryAndTags } = res?.data?.data?.facets || {}
      this.$store.commit('search/setAllCategoriesAndTags', this.addIds(healthCategoryAndTags) || [])
    },
    async fetchGeolocationData() {
      const res = await this.$geocoder.fetchGeolocationFromAddress({
        address_line_1: this.$route.query.location,
        address_line_2: '',
        city: '',
        state: '',
        zip_code: '',
        country: 'UK',
      })
      const location = res?.data?.results?.[0]?.geometry?.location || {}
      const { lat, lng } = location
      this.$store.commit('search/setGeolocation', { latitude: lat, longitude: lng })
    },
    getCategoryByTag(tag) {
      const { allCategoriesAndTags } = this
      const cat = allCategoriesAndTags.find(c => c.tags?.find(t => t.name === tag))
      const { category: name, tags } = cat
      return { ...cat, name, tags, text: name, value: name }
    },
    async handleSearchedTagOnInitialLoad(tag) {
      const cat = this.getCategoryByTag(tag)
      this.$store.commit('search/setSelectedCategory', cat)
      const sTag = cat.tags.find(t => t.name === tag)
      this.$store.commit('search/setSelectedTag', sTag)
      if (window.innerWidth > MOBILE_WIDTH) alterHeaderSearchValue(tag)
      else alterMobileHeaderSearchValue(tag)
    },
    async onCreated() {
      await this.setInitialFilterValues()
      await this.emptyFetch()
      await this.setTagIfPassedInSearchString()
      await fetch(this)
    },
    onFilterSelected(e) {
      handleFilterSelected(this, e)
    },
    onSort() {
      fetch
    },
    async setInitialFilterValues() {
      const { location = '', query, search = '' } = this.$route.query
      this.$store.commit('search/setQuery', query || '*')
      if (location) await this.fetchGeolocationData()
      if (search) this.$store.commit('search/setSearch', search)
      if (this.$store.getters['search/hasLocation']) {
        this.$store.commit('search/setSortBy', 'distance')
        this.$store.commit('search/setSortOrder', 'asc')
      }
    },
    async setTagIfPassedInSearchString() {
      const decoded = this.$store.getters['search/decodedSearchString']
      const tags = decoded?.facetDef?.['Health Tag'] || []
      const tag = tags[0] || null
      if (tag) await this.handleSearchedTagOnInitialLoad(tag)
    },
  },
}
</script>
